/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：325
 */

"use strict"

var r = require(/* 1035 */"./1199/1035")
var i = "object" == typeof self && self && self.Object === Object && self
var o = r.a || i || Function("return this")()
exports.a = o
